var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check",
    clipPath: "url(#clip0_3898_32762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.2981 8.46742L11.6381 21.1549C10.7006 22.0949 9.18062 22.0949 8.24062 21.1549L1.70312 14.6049C0.765625 13.6649 0.765625 12.1399 1.70312 11.1999C2.64062 10.2599 4.16313 10.2599 5.10063 11.1999L9.93812 16.0474L20.9006 5.06242C21.8381 4.12242 23.3606 4.12242 24.2981 5.06242C25.2356 6.00242 25.2356 7.52492 24.2981 8.46742Z",
    fill: "#00FF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3898_32762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.5 0.167969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.5cf57229bd05f41af8b1e951bc326186.svg";
export { ForwardRef as ReactComponent };